var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCircularRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 32.00 32.00",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: " M 18.12 0.00 Q 28.91 2.06 32.00 12.49 L 32.00 19.40 Q 29.21 29.73 18.52 32.00 L 14.46 32.00 Q 1.84 29.60 0.28 17.51 Q -0.35 12.68 2.61 7.61 Q 6.29 1.30 14.50 0.00 L 18.12 0.00 Z M 18.41 16.03 Q 18.41 16.09 18.40 16.14 Q 18.39 16.21 18.34 16.25 Q 15.53 18.97 13.18 21.51 A 1.36 1.33 62.2 0 0 12.84 22.65 Q 13.11 24.34 14.87 23.80 A 1.58 1.56 14.3 0 0 15.50 23.43 Q 18.73 20.36 21.73 17.25 Q 22.26 16.70 22.26 16.02 Q 22.26 15.33 21.73 14.79 Q 18.71 11.69 15.46 8.64 A 1.58 1.56 -14.6 0 0 14.83 8.27 Q 13.07 7.74 12.81 9.43 A 1.36 1.33 -62.5 0 0 13.15 10.57 Q 15.52 13.10 18.34 15.80 Q 18.39 15.84 18.40 15.91 Q 18.41 15.97 18.41 16.03 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCircularRightArrow);
export default __webpack_public_path__ + "static/media/grayCircularRightArrow.8a8df59c2c7c5dac86634ef752c0e43f.svg";
export { ForwardRef as ReactComponent };